import React, { useEffect, useMemo } from "react";
import { TabsCardLayout } from "@icoach/components";
import MemberDetailBasicInfoContentInfo from "@icoach/memberDetail/MemberDetailBasicInfoContentInfo";
import MemberDetailBasicInfoContentInvoice from "@icoach/memberDetail/MemberDetailBasicInfoContentInvoice";
import MemberDetailBasicInfoContentPayment from "@icoach/memberDetail/MemberDetailBasicInfoContentPayment";
import useTabState from "@util/hook/useTabState";
import useSwitch from "@util/hook/useSwitch";
import { isEqual } from "@util/utils";
import { MEMBER_DETAIL_TABS_MAP } from "@icoach/memberDetail/staticData";

const MemberDetailBasicInfoContent = ({ className, memberID }) => {
	const { activeTab, handleTabChange } = useTabState(MEMBER_DETAIL_TABS_MAP.INFO);
	const { isOn: isEdit, handleToggle, handleTurnOff: handleCloseEdit } = useSwitch(false);
	const isCurrentTabInfo = isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.INFO);
	const tabData = useMemo(
		() => {
			return [
				{
					label: "基本資料",
					value: MEMBER_DETAIL_TABS_MAP.INFO,
				},
				{
					label: "付款資料",
					value: MEMBER_DETAIL_TABS_MAP.PAYMENT,
				},
				{
					label: "管理發票",
					value: MEMBER_DETAIL_TABS_MAP.INVOICE,
				},
			];
		},
		// eslint-disable-next-line
		[]
	);

	const infoActionData = useMemo(
		() => {
			return [
				{
					label: isEdit ? "取消編輯" : "編輯資料",
					variant: "outlined",
					onClick: handleToggle,
				},
			];
		},
		// eslint-disable-next-line
		[isEdit]
	);

    // 暫時這樣寫 by Allen
	useEffect(
		() => {
			if (!isCurrentTabInfo) {
				handleCloseEdit();
			}
		},
		// eslint-disable-next-line
		[isCurrentTabInfo]
	);

	return (
		<TabsCardLayout
			className={className}
			activeTab={activeTab}
			tabs={tabData}
			actions={isCurrentTabInfo && infoActionData}
			onTabChange={handleTabChange}
			tabsContent={{ className: "pt-3 px-3 pb-3" }}
		>
			{isCurrentTabInfo && <MemberDetailBasicInfoContentInfo memberID={memberID} isEdit={isEdit} onCloseEdit={handleCloseEdit} />}
			{isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.PAYMENT) && <MemberDetailBasicInfoContentPayment memberID={memberID} />}
			{isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.INVOICE) && <MemberDetailBasicInfoContentInvoice memberID={memberID} />}
		</TabsCardLayout>
	);
};

export default MemberDetailBasicInfoContent;
